<template>
    <div>
        <v-row no-gutters>
            <v-col>
                <h4 class="text-h4">{{$t("customers")}}</h4>
                <p class="text-subtitle-1">{{$t("customers_list")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn
                    color="primary"
                    block
                    :disabled="authorizations.customers ? !authorizations.customers.create : true"
                    @click="openCustomerDialog({editMode: false})"
                    >
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("new_customer")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu
                    offset-y
                    min-width="300"
                    :close-on-content-click="false"
                    v-model="display.search">
                    <template v-slot:activator="{on}">
                        <v-btn
                            block
                            depressed
                            v-on="on">
                            <v-icon left>mdi-magnify</v-icon>
                            Search
                        </v-btn>
                    </template>
                    <customer-search-menu
                        :loading="loading.data"
                        @submit="onSearchMenuSubmit"
                    />
                </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field
                    :label="$t('code')"
                    outlined
                    rounded
                    v-model="codeSearch"
                    dense
                    prepend-inner-icon="mdi-magnify"
                    hide-details>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                        v-model="selected.customer"
                        @dblclick:row="onDblClickRow"
                        dense
                        :options.sync="options"
                        :server-items-length="customersLength"
                        :loading="loading.data"
                        :items="customers"
                        :headers="headers.customer"
                        :footer-props="{ 'items-per-page-options': [5,10,15] }"
                        @contextmenu:row="openContextMenu"
                        >
                        <template v-slot:[`item.code`]="{item}">
                            <v-btn icon @click="openCustomerDisplayDialog(item)">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            {{item.code}}
                        </template>
                        <template v-slot:[`item.balance`]="{item}">
                            {{ formatMoney(item.balance) }}
                        </template>
                        <template v-slot:[`item.created_at`]="{item}">
                            {{ moment(item.created_at).format('YYYY-MM-DD')}}
                        </template>
                    </v-data-table>
            </v-col>
        </v-row>
        <CustomerDialog
            @submit="refreshDataFetch"
            ref="customerDialog"/>
        <DeleteDialog
            ref="deleteDialog"
            @submit="onDeleteDialogSubmit"/>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <CustomerDisplayDialog
            ref="customerDisplayDialog"/>
        <CustomerStatementDisplayDialog
            ref="customerStatementDisplayDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <ContextMenu
            v-if="contextMenu.display"
            :position="contextMenu.position"
            :items="contextMenuItems"
            @contextmenu:click="contextMenuClicked"/>
    </div>
</template>
<script>
import CustomerDialog from '@/components/Sales/CustomerDialog';
import CustomerStatementDisplayDialog from '@/components/Sales/CustomerStatementDisplayDialog';
import AlertDialog from '@/components/common/AlertDialog';
import RetryDialog from '@/components/common/RetryDialog';
import DeleteDialog from '@/components/common/DeleteDialog';
import CustomerDisplayDialog from '@/components/Sales/CustomerDisplayDialog';
import accounting from 'accounting';
import { mapState, mapActions } from 'vuex';
import ContextMenu from '@/components/common/ContextMenu';
import CustomerSearchMenu from '../../components/Sales/CustomerSearchMenu.vue';
import moment from 'moment';
export default {
    name: "Customers",
    components: {
        RetryDialog,
        DeleteDialog,
        AlertDialog,
        CustomerDialog,
        CustomerDisplayDialog,
        CustomerStatementDisplayDialog,
        ContextMenu,
        CustomerSearchMenu,
    },
    data() {
        return {
            customersLength: 0,
            selected: {
                customer: []
            },
            loading: {
                data: false,
                customer: false
            },
            headers: {
                customer: [
                    { text: this.$t('code'), value: "code" },
                    { text: this.$t('name'), value: "name" },
                    { text: this.$t('customer_group'), value: "customer_group" },
                    { text: this.$t('phone'), value: "phone" },
                    { text: this.$t('created_by'), value: 'created_by'},
                    { text: this.$t('sales_person'), value: 'sales_person'},
                    { text: this.$t('created_at'), value: 'created_at'},
                    { text: this.$t('balance'), sortable: false, value: "balance" }
                ]
            },
            search: null,
            display: {
                search: false
            },
            options: {},
            contextMenu: {
                display: false,
                position: {
                    x: 0,
                    y: 0,
                }
            },
            codeSearch: null
        }
    },
    computed: {
        ...mapState("sales/customer", ["customers"]),
        ...mapState('authentication', ["authorizations"]),
        contextMenuItems() {
            return [
                    { title: this.$t("show_customer"), icon: "mdi-eye", action: "openCustomerDisplayDialog", disabled: !this.authorizations.customers.read},
                    { title: this.$t("edit_customer"), icon: "mdi-pencil", action: "openCustomerEditDialog", disabled: !this.isEditable},
                    { title: this.$t("delete_customer"), icon: "mdi-delete", action: "openCustomerDeleteDialog", disabled: !this.isDeletable}
            ]
        },
        isDeletable() {
            return this.getSelectedCustomer.meta.deletable && this.authorizations.customers.delete
        },
        isEditable() {
            return this.getSelectedCustomer.meta.editable && this.authorizations.customers.update
        },
        getSelectedCustomer()
        {
            console.log("hi")
            return this.selected.customer[0];
        }
    },
    watch: {
        options: {
            handler() {
                this.createdDataFetch();
            },
            deep: true
        },
        codeSearch(value) {
            this.options = {
                ...this.options,
                code: value
            }
        }
    },
    methods: {
        ...mapActions("sales/customer", ["fetchCustomers", "removeCustomers", "searchCustomer"]),
        moment,
        async createdDataFetch() {
            try {
                this.loading.data = true;
                this.options.search = this.search;
                let result = await this.fetchCustomers(this.options);
                this.customersLength = result.data.total;
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        formatMoney(amount) {
            return accounting.formatMoney(amount, "SDG ", 2);
        },
        openCustomerDialog(params){
            this.$refs.customerDialog.open(params);
        },
        openCustomerEditDialog()
        {
            this.openCustomerDialog({id: this.getSelectedCustomer.id, editMode: true});
        },
        openCustomerDeleteDialog()
        {
            this.openDeleteDialog({target: "customer", name: "name", items: this.selected.customer});
        },
        openDeleteDialog(params) {
            this.$refs.deleteDialog.open(params);
        },
        clearSelectedCustomer()
        {
            this.selected.customer = [];
        },
        selectCustomer(customer)
        {
            this.clearSelectedCustomer();
            this.selected.customer.push(customer);
        },
        openCustomerDisplayDialog(customer) {
            console.log(customer)
            this.$refs.customerDisplayDialog.open(customer);
        },
        openContextMenu(e, payload) {
            e.preventDefault();
            this.contextMenu.position.x = e.clientX
            this.contextMenu.position.y = e.clientY
            this.contextMenu.display = false;
            this.$nextTick(() => {
                this.contextMenu.display = true;
            });
            this.selectCustomer(payload.item);
        },
        contextMenuClicked(action) {
            this[action]();
        },
        openCustomerStatementDisplayDialog(params) {
            this.$refs.customerStatementDisplayDialog.open(params);
        },
        refreshDataFetch() {
            this.search = null;
            this.createdDataFetch();
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'customer') {
                this.removeCustomers({itemsIds: params.itemsIds})
                    .then(() => {
                        this.$refs.deleteDialog.close();
                        this.createdDataFetch();
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        onSearchMenuSubmit(searchForm) {
            this.codeSearch = null;
            this.options.page = 1;
            this.options = {...this.options, ...searchForm};
            // this.getCustomer();
        },
        onDblClickRow(e, row) {
            this.openCustomerDisplayDialog(row.item)
        }
    },

}
</script>

<style lang="sass" scoped>

</style>